import React from 'react'
import { connect } from 'react-redux'
import { store } from "../store"
import { push } from "react-router-redux"
import agent from '../agent'
import numberHelper from '../util/numberFormatter'
import Loading from './widgets/Loading'
import Header from './widgets/Header'
import FileList from './widgets/FileList'
import { Link } from 'react-router-dom'
import Nav from './widgets/Nav'
import Util from '../util/util'
import ReactModal from 'react-modal'
import ListErrors from './widgets/ListErrors'
import {
  FILE_LIST_PAGE_LOADED,
  FILE_LIST_PAGE_UNLOADED,
} from '../constants/actionTypes'
import _ from 'lodash'
import role from '../util/role'
import { Translation } from 'react-i18next'
import i18n from '../languages/lang.js'

const mapStateToProps = state => ({
  ...state.file,
  currentUser: state.common.currentUser,
  inProgress: state.common.inProgress
})

const mapDispatchToProps = dispatch => ({
  onLoad: (payload) => {
    dispatch({ type: FILE_LIST_PAGE_LOADED, payload })
  },
  onUnload: () =>
    dispatch({ type: FILE_LIST_PAGE_UNLOADED }),

})

class Files extends React.Component {
  constructor() {
    super()
    this.state = {
      directory: '',
    }
  }
  componentWillMount() {
    if (this.props.currentUser) {
      let search = this.props.location.search
      let directory
      if (search) {
        let args = Util.getQueryStringArgs(search.toLowerCase())
        directory = args.directory ? args.directory : ''
        this.setState({ directory: directory })
      }
      let payload = directory || directory === 'root' ? agent.Files.getDirectoryDetail(directory) : agent.Files.getRootDirectory()
      this.props.onLoad(payload)
    } else {
      store.dispatch(push("/login"))
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      let search = nextProps.location.search
      let directory
      if (search) {
        let args = Util.getQueryStringArgs(search.toLowerCase())
        directory = args.directory ? args.directory : ''
        this.setState({ directory: directory })
      }
      let payload = directory ? agent.Files.getDirectoryDetail(directory) : agent.Files.getRootDirectory()
      this.props.onLoad(payload)
    }
  }
  componentWillUnmount() {
    this.props.onUnload()
  }

  render() {
    if (!this.props.files) {
      return (
        <Loading selected={'files'} currentUser={this.props.currentUser} />
      )
    }
    const directory = this.props.directory
    const files = this.props.files
    const sub_directories = this.props.sub_directories
    const currentUser = this.props.currentUser
    const directory_path = Util.generateDirectoryPath(directory)
    return (
      <Translation>
        {
          (t) => (
            <div id="main">
              <Nav selected={'files'} currentUser={this.props.currentUser} />
              <div id="content">
                <Header />
                {this.state.subscribe}
                <div id="content-wrap">
                  <div className='box-header'>
                    <Link className='header-button' to={`/upload?directory=${directory.key || ''}&name=${directory.name}`}>{t('file.upload_button')}</Link>
                    <Link className='header-button' to={`/directories/add?parent=${directory.key || ''}`}> {t('file.create_directory_button')}</Link>
                    {directory.key !== 'root' && (directory.owner === currentUser.key || role.isFileAdmin(currentUser.role)) ?
                      <Link className='header-button' to={`/directories/${directory.key}/edit`}> {t('file.edit_directory_button')}</Link>
                      : null}

                    <h2>{directory_path} {files.length > 0 ? files.length > 1 ? <span> - {files.length} files</span> : <span> - {files.length} file</span> : null}</h2>
                  </div>
                  <FileList directories={sub_directories} directory={directory} data={files} />
                  <strong className='list-footer'>{t('file.label_total')}: {files.length} files</strong>
                </div>
              </div>
            </div >
          )
        }
      </Translation>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Files)
